export default __webpack_public_path__ + "static/media/bathroom.790134f6.svg";